import axios from "axios";
import {authorizationServicesPath} from "../../Constants";

export default class CustomerService {
    static async getAll() {
        return axios.get(authorizationServicesPath + "/customers/customer");
    }

    static async edit(data) {
        const addressId = data.address?.id;
        const residentialAddressId = data.residentialAddress?.id;
        return axios.patch(
            `${authorizationServicesPath}/customers/customer?addressId=${addressId}&residentialAddressId=${residentialAddressId}`,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            },
        );
    }

    /**
     * Привязка уже существующего адреса из справочника (один за вызов).
     * addressType: ADDRESS | RESIDENTIAL_ADDRESS
     */
    static async updateAddress(addressType, addressId) {
        return axios.patch(
            `${authorizationServicesPath}/customers/customer/update-address?addressType=${addressType}&addressId=${addressId}`,
            [],
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            },
        );
    }
}
